import { Payload } from "./payload";

export class NotificaAttivita {
  idNotifica: string;
  destinatario: string;
  testo: string;
  oggetto: string;
  tipoInvio: string;
  letta: boolean;
  dataEmissione: number;
  eliminata: boolean;
  payload: Payload;
  mittente: string;
  rimosso:boolean;
}

export enum TIPO_NOTIFICA {
  ELABORAZIONE_DOCUMENTI = 'elaborazione_documenti'
}
